import DirHandler from "../../../Utils/dir";

import type { BaseFilesRepository } from "./BaseFilesRepository.interface";

class ExperimentalFilesRepository implements BaseFilesRepository {
  async readFile(directory: string, fileName: string): Promise<Blob | null> {
    const file = await DirHandler.readFile(directory, fileName);

    return file.content;
  }

  async uploadFile(
    directory: string,

    fileName: string,

    file: Blob,

    _onProgress?: (progress: number) => void,
  ) {
    await DirHandler.createFile(directory, fileName, file);

    return true;
  }

  async createDirectory(directoryPath: string) {
    try {
      await DirHandler.getDirHandle(directoryPath, true);

      return true;
    } catch (error) {
      console.error("❌ Error creating directory:", error);

      return false;
    }
  }
}

export default ExperimentalFilesRepository;
